var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase } from "@mui/material";
export default function Endereco(_a) {
    var children = _a.children, mapLink = _a.mapLink;
    return (_jsx(ButtonBase, __assign({ href: mapLink, target: "_blank", sx: {
            p: 2,
            backgroundColor: "white",
            borderRadius: 2,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            justifyContent: "flex-start",
            "& .map": {
                width: "100%",
                height: "100%",
            },
        } }, { children: children })));
}
